import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function Description({ description, descriptionAr, product }) {
  const { i18n, t } = useTranslation();

  return (
    <div className="description">
      <h3>{t("Product Description")}</h3>
      <div className="box">
        <div>{i18n.language == "ar" ? descriptionAr : description}</div>
      </div>
      {/* {product?.product?.pdfUrl && (
        <p>
          <a href={product?.product?.pdfUrl} download>
            كتالوج المنتج ( PDF )
          </a>
        </p>
      )} */}
      {product?.product?.sizeGuidelines.length > 0 && (
        <p>
          <a href={product?.product?.sizeGuidelines[0]?.secure_url} download>
          {t("Size Guide")}( PDF )
          </a>
        </p>
      )}
    </div>
  );
}
export default Description;
